/* Nouvè — theme interactions */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sticky header state */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 12) header.classList.add('is-stuck');
      else header.classList.remove('is-stuck');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile nav */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('nav-open', open);
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        document.body.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* FAQ accordion */
  function initFaq() {
    document.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-faq-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Before / after slider */
  function initBeforeAfter() {
    document.querySelectorAll('[data-ba]').forEach(function (ba) {
      var top = ba.querySelector('[data-ba-top]');
      var handle = ba.querySelector('[data-ba-handle]');
      if (!top || !handle) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = ba.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        top.style.width = pct + '%';
        handle.style.left = pct + '%';
        ba.setAttribute('aria-valuenow', Math.round(pct));
      }
      var start = function () { dragging = true; };
      var stop = function () { dragging = false; };
      var move = function (e) {
        if (!dragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(x);
      };
      handle.addEventListener('mousedown', start);
      handle.addEventListener('touchstart', start, { passive: true });
      window.addEventListener('mouseup', stop);
      window.addEventListener('touchend', stop);
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: true });
      ba.addEventListener('click', function (e) {
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(x);
      });
      handle.addEventListener('keydown', function (e) {
        var cur = parseFloat(ba.getAttribute('aria-valuenow') || '50');
        if (e.key === 'ArrowLeft') { cur -= 4; }
        else if (e.key === 'ArrowRight') { cur += 4; }
        else return;
        cur = Math.max(0, Math.min(100, cur));
        top.style.width = cur + '%';
        handle.style.left = cur + '%';
        ba.setAttribute('aria-valuenow', Math.round(cur));
        e.preventDefault();
      });
    });
  }

  /* Scroll reveal */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Cart drawer */
  function initCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (!drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('cart-open');
      drawer.setAttribute('aria-hidden', 'false');
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('cart-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); refresh().then(open); });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () {});
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function renderCart(cart) {
      var body = drawer.querySelector('[data-cart-body]');
      var count = document.querySelectorAll('[data-cart-count]');
      var subtotal = drawer.querySelector('[data-cart-subtotal]');
      count.forEach(function (c) { c.textContent = cart.item_count; });
      if (subtotal) subtotal.textContent = money(cart.total_price);
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
        return;
      }
      body.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image + '" alt="" width="72" height="90" loading="lazy">' : '';
        return '<div class="cart-line" data-key="' + item.key + '">' +
          '<div class="cart-line__media">' + img + '</div>' +
          '<div class="cart-line__info">' +
          '<p class="cart-line__title">' + item.product_title + '</p>' +
          '<p class="cart-line__meta">Qty ' + item.quantity + '</p>' +
          '<button class="cart-line__remove" data-cart-remove="' + item.key + '" type="button">Remove</button>' +
          '</div>' +
          '<div class="cart-line__price">' + money(item.final_line_price) + '</div>' +
          '</div>';
      }).join('');
      body.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          changeQty(btn.getAttribute('data-cart-remove'), 0);
        });
      });
    }

    function changeQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }

    /* Intercept add-to-cart forms */
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (r) { return r.json(); })
          .then(function () { return refresh(); })
          .then(open)
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
      });
    });

    refresh();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initMobileNav();
    initFaq();
    initBeforeAfter();
    initReveal();
    initCart();
  });
})();
